import { getHours, getMinutes, getSeconds } from 'date-fns';

export default function checkIsDateMidnight(date: Date) {
  return (
    getHours(date) === 23 && getMinutes(date) === 59 && getSeconds(date) === 59
  );
}
